import { useIntl } from "react-intl";

import { getLocalizedHref, useLocale } from "@/libraries/web-framework";
import { DropdownContent } from "@/patterns/global-nav/src/dropdown-content";

import { useJiraTemplateCategories } from "./client";

export const TemplateCategoriesDropdown = () => {
    const locale = useLocale();
    const intl = useIntl();
    const { data } = useJiraTemplateCategories();

    const allTemplateLink = {
        text: intl.formatMessage({
            id: "ira.TemplateCategoriesDropdown.allTemplates",
            defaultMessage: "All templates"
        }),
        href: getLocalizedHref({
            href: "/software/jira/templates",
            locale
        })
    };

    const templateLinks = data.map((category) => ({
        text: category.categoryNameExternal,
        href: getLocalizedHref({
            href: `/software/jira/templates/${category.urlSlug}`,
            locale
        })
    }));

    const jsmTemplatesLink = {
        text: intl.formatMessage({
            id: "Jira.TemplateCategoriesDropdown.JiraServiceManagementTemplates",
            defaultMessage: "Jira Service Management templates"
        }),
        href: getLocalizedHref({
            href: "/software/jira/templates/service-management",
            locale
        }),
        anchorProps: {
            target: "_blank"
        }
    };

    return (
        <DropdownContent
            orientation="column"
            contentSections={[
                {
                    links: [allTemplateLink, ...templateLinks]
                },
                {
                    links: [jsmTemplatesLink]
                }
            ]}
        />
    );
};
